export default __webpack_public_path__ + "static/media/bee2_short.c4c32ebf.jpg";